import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import { UNDER_CONSTRUCTION_PATH } from '@/shared/config';

const search = z.object({ caminho: z.string().max(2048).optional().catch(undefined) });

// Endereço antigo da explicação (D11): links salvos caem na tela "Em construção" com o mesmo caminho.
export const Route = createFileRoute('/_app/legado-indisponivel')({
  validateSearch: search,
  beforeLoad: ({ search: { caminho } }) => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error -- redirect() é o contrato do TanStack Router.
    throw redirect({ to: UNDER_CONSTRUCTION_PATH, search: caminho ? { caminho } : {}, replace: true });
  },
});
